import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { ContactForm } from './ContactForm';
import { useLanguage } from '../contexts/LanguageContext';

export const ContactDialog = ({ open, onOpenChange, source }) => {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl">
            {t('home.finalCta.title')}
          </DialogTitle>
          <DialogDescription>
            {t('home.finalCta.text')}
          </DialogDescription>
        </DialogHeader>
        <ContactForm source={source} onSuccess={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
};